import { useState } from 'react';

const faqs = [
  {
    question: 'What is Superbuy Spreadsheet?',
    answer:
      'The Superbuy Spreadsheet is a community-curated database of product links from Chinese marketplaces like Taobao and Weidian. It organizes thousands of finds into easy-to-browse categories, complete with QC photos, sizing information, and price references. Instead of spending hours hunting for products manually, you can browse a structured spreadsheet that is regularly updated with the latest trending items.',
  },
  {
    question: 'Is Superbuy Spreadsheet safe to use?',
    answer:
      'Yes, the Superbuy Spreadsheet is safe when used properly. The spreadsheet itself is just a collection of product links — it does not handle payments or store personal data. We recommend always checking seller ratings, reviewing QC photos before purchasing, and using trusted agents for shipping. The spreadsheet helps you find products faster, but you should still follow standard safe shopping practices.',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer:
      'The Superbuy Spreadsheet is updated on a regular basis with new product finds, removed dead links, and refreshed categories. Community members and curators continuously contribute new discoveries, ensuring that the database stays current with the latest trends. Major updates typically roll out every few weeks.',
  },
  {
    question: 'How do I use Superbuy Spreadsheet?',
    answer:
      'Using the Superbuy Spreadsheet is straightforward. Browse through the organized categories to find products you are interested in, click on the product links to view item details, check QC photos and reviews when available, then use your preferred shopping agent to purchase. The spreadsheet is designed to be beginner-friendly with clear categorization.',
  },
  {
    question: 'What products can I find in the spreadsheet?',
    answer:
      'The spreadsheet covers a wide range of categories including shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes, and more. From streetwear to luxury-inspired items, the database spans popular styles and trending fashion pieces across multiple marketplaces.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full border border-accent-300/50 bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Everything you need to know about the Superbuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-5 h-5 shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}